
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import ScrollToPlugin from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import loadComponents from 'gia/loadComponents';
import config from 'gia/config';
import _map from 'lodash.map' 


//import Animation from './animation'
import Cover from './cover'
import Discover from './discover'
import Fyi from './fyi'
import Expert from './expert'
import Heart from './heart'
import Percent from './percent'
import Challenge from './challenge'
import Trust from './trust'
import Services from './services'
import Benefits from './benefits'
import Video from './video'
import Boxes from './boxes'
import Contact from './contact'
import Partners from './partners'
import Certificates from './certificates'

import Events from './events'
import Counter from './counter'
import lazySizes from 'lazysizes';

class App {

  constructor($) {
    this.create()
  }

  create() {

      lazySizes.init()
      config.set('log', false); // disables unnecessary console.log calls

      const components = {

        //Animation: Animation
        Cover: Cover,
        Discover: Discover,
        Services: Services,
        Benefits: Benefits,
        Contact: Contact,
        Partners: Partners,
        Certificates: Certificates,
        Counter: Counter,
        Events: Events,
        Boxes: Boxes,
        Percent: Percent,
        Trust: Trust,
        Challenge: Challenge,
        Video: Video,
        Fyi: Fyi,
        Heart: Heart,
        Expert: Expert
      }

      loadComponents(components)

      $('body').addClass('loaded')

      $('.lang__current').on('click', () => {
       
        $('.lang').toggleClass('lang__opened')
      })

      $('.schedule-button').on('click', (e) => {
        
        $('.section-schedule').toggleClass('section-schedule--opened')
      })

      $('.schedule__close').on('click', (e) => {
        e.preventDefault()
        $('.section-schedule').removeClass('section-schedule--opened')
      })

      $('#hamburger').on('click', (e) => {
        $('body').toggleClass('has-menu')
      })
      $('.menu a').on('click', (e) => {
        $('body').removeClass('has-menu')
      })

      

    //  fetch('/data/ink.json')
    //    .then((response) => response.json())
    //    .then((json) => {
          
    //      const arr = _map(json, 'ink');
    //      const jso = document.getElementById('json')
    //    console.log(arr);
    //     jso.innerHTML = arr.toString()

    //    });

  }


}

module.exports = App
